// in src/i18nProvider.js
import polyglotI18nProvider from 'ra-i18n-polyglot'
import es from './ra-language-spanish'
import en from './ra-language-english';
import pt_br from './ra-language-pt-br'

const messages = {
  'es-AR': es,
  'en-US': en,
  'pt-BR': pt_br,
}

const polyglotOptions = {
  allowMissing: true,
  onMissingKey: (key, options) => {
    if (options && options._ != null) {
      return options._;
    }
    if (!key) {
      return '';
    }
    const keyParts = String(key).split('.');
    const rawName = keyParts[keyParts.length - 1] || String(key);
    return rawName.replace(/[-_]/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
  },
}

const getI18nProvider = (locale) => {
  let language = locale || localStorage.getItem('language') || 'es-AR'
  // Escuchar cambios de idioma globalmente
  window.addEventListener('languageChanged', () => {
    language = localStorage.getItem('language')
  })
  return polyglotI18nProvider(() => messages[language], language, polyglotOptions)
}

export default getI18nProvider